import { TranslationKey } from '../types/i18next';

export const ACCESS_FORBIDDEN_MESSAGE_TEXT: TranslationKey =
  'error.message.accessForbidden';
export const NO_USER_PERMISSION_MESSAGE_TEXT: TranslationKey =
  'error.message.noUserPermission';
export const INVALID_TOKEN_MESSAGE_TEXT: TranslationKey =
  'error.message.invalidTokenMessage';
export const SESSION_EXPIRED_MESSAGE_TEXT: TranslationKey =
  'error.message.sessionExpiredMessage';
export const UNKNOWN_ERROR: TranslationKey = 'error.message.unknownError';
export const NO_INTERNET_CONNECTION: TranslationKey =
  'error.message.noInternetConnection';
export const ADMIN_CONTACT_REQUIRED_WARNING_TEXT: TranslationKey =
  'error.message.adminContactRequired';
export const ONLY_ONE_ADMIN_ALLOWED: TranslationKey =
  'error.message.oneAdminAllowed';
export const ONLY_ONE_BILLING_ALLOWED: TranslationKey =
  'error.message.oneBillingAllowed';
export const BILLING_CONTACT_NOT_ASSIGNED: TranslationKey =
  'error.message.billingContactNotAssigned';
export const ONLY_ONE_ADMIN_AND_BILLING_ALLOWED: TranslationKey =
  'error.message.onlyOneAdminAndBillingAllowed';
export const DUPLICATED_EMAIL: TranslationKey = 'error.message.duplicatedEmail';
export const EMAIL_EXISTS: TranslationKey = 'error.message.emailExist';
export const POC_CONTACTS_USE_FROM_CLIENT: TranslationKey =
  'error.message.pocConactsUseFromClient';
export const POC_CONTACTS_USE_FROM_CLIENT_JOB: TranslationKey =
  'error.message.pocContactsUseFromClientJob';
export const STATUS_UPDATED_BY_JOBLIO: TranslationKey =
  'error.message.statusUpdatedJoblio';

//API response Error messages constants
export const ACCOUNT_NOT_ACTIVATED_MESSAGE_TEXT: string =
  'Your account is not yet activated for Client Workspace access.';
export const APPLICATION_MUST_BE_IN_NEW_OR_REVIEW_STAGE_MESSAGE_TEXT: string =
  'Application must be in New or Review stage.';

//API response messages Map
export const RESPONSE_MESSAGE_LANGUAGE_KEY_MAP: Record<string, TranslationKey> =
  {
    [APPLICATION_MUST_BE_IN_NEW_OR_REVIEW_STAGE_MESSAGE_TEXT]:
      'error.message.applicationMustBeInNewOrReviewStage'
  };
